var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cache)?_c('keep-alive',[_c('router-view',_vm._b({},'router-view',_vm.$attrs,false))],1):_c('router-view',_vm._b({},'router-view',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }